var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPvdAlertInfoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6244 0.00716485 23.9928 5.37555 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM11.9989 2C6.47657 2.00058 2 6.47751 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12.0022C21.994 6.48096 17.52 2.00656 11.9989 2ZM11.5 9.5C12.6046 9.5 13.5 10.3954 13.5 11.5V16.25C13.5 16.3881 13.6119 16.5 13.75 16.5H14.5C15.0523 16.5 15.5 16.9477 15.5 17.5C15.5 18.0523 15.0523 18.5 14.5 18.5H10.5C9.94771 18.5 9.5 18.0523 9.5 17.5C9.5 16.9477 9.94771 16.5 10.5 16.5H11.25C11.3881 16.5 11.5 16.3881 11.5 16.25V11.75C11.5 11.6119 11.3881 11.5 11.25 11.5H10.5C9.94771 11.5 9.5 11.0523 9.5 10.5C9.5 9.94771 9.94771 9.5 10.5 9.5H11.5ZM11.7308 5.55037C12.4212 5.55037 12.9808 6.11001 12.9808 6.80037C12.9808 7.49072 12.4212 8.05037 11.7308 8.05037C11.0404 8.05037 10.4808 7.49072 10.4808 6.80037C10.4808 6.11001 11.0404 5.55037 11.7308 5.55037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvdAlertInfoOutline);
export default __webpack_public_path__ + "static/media/pvd-alert-info-outline.ad29df5bb39428517f4ed0c6029e6d2d.svg";
export { ForwardRef as ReactComponent };